import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import searchImage from "../../../common/images/search.svg";
import { setCurrentPage, setSearchTerm } from "../ReviewSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useGetCertificatesQuery } from "../../../common/api/certificate";
import Skeleton from "react-loading-skeleton";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import { CertificateStatusEnum } from "../../../common/enums/CertificateStatusEnum";
import { debounce } from "../../../common/utils/debounce";
import { JSX } from "react";

export const ReviewHeader = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { currentPage, itemsPerPage, searchTerm } = useAppSelector(
        (state) => state.review,
    );
    const { data: certificates, isLoading } = useGetCertificatesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            establishment_id: useEstablishmentId(),
            search: searchTerm,
            status: CertificateStatusEnum.PENDING,
        },
    });

    if (isLoading) {
        return (
            <Skeleton
                width={"100%"}
                count={2}
                height={"4rem"}
                borderRadius={"1.5rem"}
            />
        );
    }

    if (!certificates) {
        return null;
    }

    return (
        <div className="p-review__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /{" "}
                    <Link to={RouteEnum.QUALIFICATIONS}>Kwalificaties</Link> /{" "}
                    <Link to={RouteEnum.REVIEWS}>Goedkeuren/beoordelen</Link>
                </span>
            </div>
            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Goedkeuren/Beoordelen ({certificates?.meta?.total})</h2>
                </div>
                <div className="c-header-search__search">
                    <InputField
                        placeHolder={"Zoeken..."}
                        iconRight={searchImage}
                        onChange={debounce((value: string) => {
                            dispatch(setSearchTerm(value));
                            dispatch(setCurrentPage(1));
                        })}
                    />
                </div>
            </div>
        </div>
    );
};
